import { isLocalUrl } from '../localjs';
export default function () {
  const widgetName = 'snowCards';
  const widgetOpts = snowCardsOpts;

  const wrapContainerClass = 'snowCards-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 5,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        createCustomCards($widget, data.items);
        addHoverClass($widget);
      }
    },
  });
}

// ===============================================
// ===============================================
// helpers functions
// _______

// function to create custom cards
function createCustomCards(widgetElement, widgetData) {
  widgetElement.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $cardItem = $(this);
    let urlValidation = URL !== null ? 'href="' + URL + '"' : '';
    let targetValidation = !isLocalUrl(URL) && URL ? 'target="_blank"' : '';

    $cardItem.replaceWith(`
        <div class="card-widget-item${!urlValidation ? ' void-link' : ''}"> 
          <a ${urlValidation} class="card-content${!urlValidation ? ' void' : ''}" ${targetValidation}>
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
           </a>
        </div>
        `);
  });
}

// adding custom class for hover effect
function addHoverClass(widgetElement) {
  widgetElement
    .find(`.card-widget-item:not(.void-link)`)
    .find('.card-content')
    .each(function () {
      handleHoverEffects(this);
    });
}

// function when hover in on content
function handleHoverIn(element) {
  $(element).parents('.card-widget-item').removeClass('hover-out').addClass('hover-in');
}

// function when hover out on content
function handleHoverOut(element) {
  $(element).parents('.card-widget-item').removeClass('hover-in').addClass('hover-out');
  $(element).parents('.card-widget-item').removeClass('hover-out');
}

// hover functions to prevent elements collisions
function handleHoverEffects(element) {
  $(element)
    .on('mouseenter', function () {
      handleHoverIn(this);
    })
    .on('mouseleave', function () {
      handleHoverOut(this);
    })
    .on('focus', function () {
      handleHoverIn(this);
    })
    .on('blur', function () {
      handleHoverOut(this);
    });
}
